// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.version-tag {
  color: silver;
  font-size: x-small;
}

.login-page {
  background-color: #1a3f66;
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

.login-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px !important;
}

.login-form-container,
.login-form-container-deactivated {
  border: solid 1px;
  border-color: rgb(231, 231, 231);
  border-radius: 8px !important;
  box-shadow: 0 0 30px rgba(54, 54, 54, 0.2);
  background-color: white !important;
}

.login-form-container-deactivated {
  pointer-events: none;
  opacity: 0.5;
}

.login-form {
  text-align: center !important;
  margin: 30px;
}

.login-logo {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-form-title,
.login-logo,
.login-footer,
.login-footer-deactivated,
.token-dialog-buttons,
.e-float-text,
.dialog-header,
.e-footer-content {
  text-align: center !important;
}

#error-username,
#error-password,
#error-keyAnswer,
#error-passwordConfirm,
.e-label-top,
.e-float-text {
  text-align: left !important;
}

.login-footer,
.login-footer-deactivated {
  margin-top: 10px !important;
  text-align: center !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  /* background-color: #f8f9fa;  */
  position: relative;
  bottom: 0;
  width: 100%;
}

.login-footer-deactivated {
  pointer-events: none;
  opacity: 0.5;
}

.login-buttons {
  margin-top: 28px !important;
  text-align: middle !important;
}

.token-dialog-buttons {
  text-align: center;
  margin: 20px;
}

.e-float-input {
  margin-top: 30px !important;
}

.dialog-header {
  margin-bottom: 25px;
}

.dialog-content {
  height: 230px !important;
  overflow: hidden !important;
}

.e-btn {
  text-transform: none !important;
}

.e-checkbox-wrapper .e-label {
  color: grey !important;
}

.e-checkbox-wrapper .e-frame.e-icons,
.e-checkbox-wrapper .e-frame.e-icons.e-check,
.e-checkbox-wrapper:hover .e-frame.e-icons.e-check {
  background-color: white !important;
  color: black !important;
  border: solid 1px;
}

.login-policy-container {
  margin-top: 50px !important;
}

.login-form-title-container {
  height: 60px;
}

.login-form-title {
  margin-top: 50px !important;
}

.form-input {
  margin-top: 10px;
}

.link-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.link-text {
  color: #c8c8c8;
  cursor: pointer;
  font-size: 12px;
  margin-top: 10px;
}

.link-text:hover {
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
}


/* .e-dialog .e-dlg-header-content  {
  display: flex;
  align-items: center;
  justify-content: center;
} */

/* .e-dialog .e-dlg-header-content .e-dlg-header {
  font-weight: bold;
  font-size: 20px;
} */

/* .e-dialog .e-footer-content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
} */


.token-input-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 30px;
}

.token-input-field {
  width: 100px !important;
  font-size: 27px !important;
  color: rgb(60, 60, 60) !important;
  border: 1px solid #ccc !important;
  border-radius: 4px !important;
  text-align: center !important;
}

.token-input-text {
  margin-top: 20px;
  font-size: 12px;
  color: #787878;
  text-align: center;
}

.custom-login-button {
  border-radius: 10px !important;
  padding: 10px 20px !important;
  background-color: grey !important;
  color: #fff !important;
  font-weight: bold !important;
  font-size: 16px !important;
  width: 130px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
}

.custom-login-button:hover {
  background-color: rgb(104, 104, 104) !important;
}

.custom-dialog-send-btn {
  background-color: #e3e3e3 !important;
}

.custom-dialog-send-btn:hover {
  background-color: #c3c3c3 !important;
}

.e-otp-input-focus {
  border-color: #1a3f66 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/login/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;AACR;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,gCAAgC;EAChC,6BAA6B;EAC7B,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;;;;EAME,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;EAC3B,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;;;AAGA;;;;GAIG;;AAEH;;;GAGG;;AAEH;;;;GAIG;;;AAGH;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,iCAAiC;EACjC,iCAAiC;EACjC,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;EACjC,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[".version-tag {\n  color: silver;\n  font-size: x-small;\n}\n\n.login-page {\n  background-color: #1a3f66;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n\n.login-container {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 400px !important;\n}\n\n.login-form-container,\n.login-form-container-deactivated {\n  border: solid 1px;\n  border-color: rgb(231, 231, 231);\n  border-radius: 8px !important;\n  box-shadow: 0 0 30px rgba(54, 54, 54, 0.2);\n  background-color: white !important;\n}\n\n.login-form-container-deactivated {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.login-form {\n  text-align: center !important;\n  margin: 30px;\n}\n\n.login-logo {\n  height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-form-title,\n.login-logo,\n.login-footer,\n.login-footer-deactivated,\n.token-dialog-buttons,\n.e-float-text,\n.dialog-header,\n.e-footer-content {\n  text-align: center !important;\n}\n\n#error-username,\n#error-password,\n#error-keyAnswer,\n#error-passwordConfirm,\n.e-label-top,\n.e-float-text {\n  text-align: left !important;\n}\n\n.login-footer,\n.login-footer-deactivated {\n  margin-top: 10px !important;\n  text-align: center !important;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 10px;\n  /* background-color: #f8f9fa;  */\n  position: relative;\n  bottom: 0;\n  width: 100%;\n}\n\n.login-footer-deactivated {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.login-buttons {\n  margin-top: 28px !important;\n  text-align: middle !important;\n}\n\n.token-dialog-buttons {\n  text-align: center;\n  margin: 20px;\n}\n\n.e-float-input {\n  margin-top: 30px !important;\n}\n\n.dialog-header {\n  margin-bottom: 25px;\n}\n\n.dialog-content {\n  height: 230px !important;\n  overflow: hidden !important;\n}\n\n.e-btn {\n  text-transform: none !important;\n}\n\n.e-checkbox-wrapper .e-label {\n  color: grey !important;\n}\n\n.e-checkbox-wrapper .e-frame.e-icons,\n.e-checkbox-wrapper .e-frame.e-icons.e-check,\n.e-checkbox-wrapper:hover .e-frame.e-icons.e-check {\n  background-color: white !important;\n  color: black !important;\n  border: solid 1px;\n}\n\n.login-policy-container {\n  margin-top: 50px !important;\n}\n\n.login-form-title-container {\n  height: 60px;\n}\n\n.login-form-title {\n  margin-top: 50px !important;\n}\n\n.form-input {\n  margin-top: 10px;\n}\n\n.link-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.link-text {\n  color: #c8c8c8;\n  cursor: pointer;\n  font-size: 12px;\n  margin-top: 10px;\n}\n\n.link-text:hover {\n  color: #fff;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n\n/* .e-dialog .e-dlg-header-content  {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n} */\n\n/* .e-dialog .e-dlg-header-content .e-dlg-header {\n  font-weight: bold;\n  font-size: 20px;\n} */\n\n/* .e-dialog .e-footer-content {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n} */\n\n\n.token-input-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 30px;\n}\n\n.token-input-field {\n  width: 100px !important;\n  font-size: 27px !important;\n  color: rgb(60, 60, 60) !important;\n  border: 1px solid #ccc !important;\n  border-radius: 4px !important;\n  text-align: center !important;\n}\n\n.token-input-text {\n  margin-top: 20px;\n  font-size: 12px;\n  color: #787878;\n  text-align: center;\n}\n\n.custom-login-button {\n  border-radius: 10px !important;\n  padding: 10px 20px !important;\n  background-color: grey !important;\n  color: #fff !important;\n  font-weight: bold !important;\n  font-size: 16px !important;\n  width: 130px !important;\n  cursor: pointer !important;\n  transition: all 0.3s ease !important;\n}\n\n.custom-login-button:hover {\n  background-color: rgb(104, 104, 104) !important;\n}\n\n.custom-dialog-send-btn {\n  background-color: #e3e3e3 !important;\n}\n\n.custom-dialog-send-btn:hover {\n  background-color: #c3c3c3 !important;\n}\n\n.e-otp-input-focus {\n  border-color: #1a3f66 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
